import DatePicker, { DatePickerProps } from 'react-datepicker';
import { Input } from './ux-react-designsystem-wrappers/Input';
import { InputCompactness } from '@ab-inbev-labs/ux-react-components';
import React, { forwardRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './DateInput.scss';

// Wrapper for the DatePicker component from react-datepicker, made to be similar in usage and style as the other
// input components from ux-react-designsystem.

// Redeclaring only some props from AbiInputProps, as DatePickerProps and AbiInputProps have overlapping fields
export type DateInputProps = DatePickerProps & {
  invalid?: boolean;
  bottomBorderOnly?: boolean;
  compact?: InputCompactness;
  errorMessage?: string;
  isLabelLeft?: boolean;
  label?: string;
  labelWidth?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DateInput = forwardRef<any, DateInputProps>((props, ref) => {
  const containerClassName = `date-input ${props.label && !props.isLabelLeft ? 'with-label' : ''} ${
    (props.compact ?? InputCompactness.Normal) === InputCompactness.Normal ? 'with-padding' : ''
  } ${props.compact === InputCompactness.Compact ? 'with-compact-height' : ''} ${
    props.isLabelLeft && props.bottomBorderOnly ? 'with-label-left-and-bottom-border-height' : ''
  }`;

  return (
    <div className={containerClassName}>
      <DatePicker
        ref={ref}
        customInput={
          <Input
            invalid={props.invalid}
            bottomBorderOnly={props.bottomBorderOnly}
            compact={props.compact}
            errorMessage={props.errorMessage}
            isLabelLeft={props.isLabelLeft}
            label={props.label}
            labelWidth={props.labelWidth}
          />
        }
        {...props}
      />
    </div>
  );
});

DateInput.displayName = 'DateInput';
